import { z } from "zod";

export const textBookExamCreateFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    question_ids: z.array(z.number()).nonempty({ message: "At least one question is required" }),
});

// new single subject for create text book exam
export const textBookExamCreateSingleSubjectBlankQuestionFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

// new single subject for upload text book exam
export const textBookExamUploadSingleSubjectBlankQuestionFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    importFile: z.string().nonempty({ message: "File is required" }),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

export const textBookExamCreateSingleSubjectFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

// new multiple subject
export const textBookExamCreateMultipleSubjectFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().optional(),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

// create & upload exam add Text Book question
export const textBookExamAddQuestion = z.object({
    section_id: z.string().optional(),
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    // questions: z.array.optional(),
})






// COMPETITIVE EXAM START
export const competitiveExamCreateFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitive Exam is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    question_ids: z.array(z.number()).nonempty({ message: "At least one question is required" }),
});

// create & upload exam add Text Book question
export const competitiveExamExamAddQuestion = z.object({
    section_id: z.string().optional(),
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    // questions: z.array.optional(),
})

// new single subject create competitive exam
export const competitiveExamCreateSingleSubjectBlankQuestionFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

// Competitive exam create multiple subject form validation
export const competitiveExamCreateMultipleSubjectFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().optional(),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

export const competitiveExamCreateSingleSubjectFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});

// new single subject for upload text book exam
export const competitiveExamUploadSingleSubjectBlankQuestionFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    importFile: z.string().nonempty({ message: "File is required" }),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
});











export const assignExamFormValidationPasswordManualReExamPasswordManual = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    password_type: z.string().optional(),
    password: z.string().nonempty({ message: "Password is required" }),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().nonempty({ message: "Re-Exam Password is required" }),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
});

export const assignExamFormValidationPasswordManualReExamPasswordAuto = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    password_type: z.string().optional(),
    password: z.string().optional(),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().optional(),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
});

export const assignExamFormValidationRandomPasswordManualReExamPassword = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    password_type: z.string().optional(),
    password: z.string().optional(),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().nonempty({ message: "Re-Exam Password is required" }),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
});

export const assignExamFormValidationRandomPasswordRandomReExamPassword = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    password_type: z.string().optional(),
    password: z.string().optional(),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().optional(),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
});

export const assignExamFormResultShowValidationPasswordManualReExamPasswordManual = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    total_exam_marks: z.number().optional(),
    password_type: z.string().optional(),
    password: z.string().nonempty({ message: "Password is required" }),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().nonempty({ message: "Re-Exam Password is required" }),
    result_publish_date: z.string().nonempty({ message: "Result Publish Date is required" }),
    result_publish_time: z.string().nonempty({ message: "Result Publish Time is required" }),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
}).refine(data => {
    const passingMarks = parseFloat(data.passing_marks);
    const totalExamMarks = parseFloat(data.total_exam_marks);

    // Ensure the parsed numbers are valid
    if (isNaN(passingMarks) || isNaN(totalExamMarks)) {
        return false;
    }

    return passingMarks <= totalExamMarks;
}, {
    message: "Passing Marks must be less than or equal to Total Exam Marks",
    path: ["passing_marks"],
});

export const assignExamFormResultShowValidationPasswordManualReExamPasswordAuto = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    total_exam_marks: z.number().optional(),
    password_type: z.string().optional(),
    password: z.string().nonempty({ message: "Password is required" }),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().optional(),
    result_publish_date: z.string().nonempty({ message: "Result Publish Date is required" }),
    result_publish_time: z.string().nonempty({ message: "Result Publish Time is required" }),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
}).refine(data => {
    const passingMarks = parseFloat(data.passing_marks);
    const totalExamMarks = parseFloat(data.total_exam_marks);

    // Ensure the parsed numbers are valid
    if (isNaN(passingMarks) || isNaN(totalExamMarks)) {
        return false;
    }

    return passingMarks <= totalExamMarks;
}, {
    message: "Passing Marks must be less than or equal to Total Exam Marks",
    path: ["passing_marks"],
});

export const assignExamFormResultShowValidationRandomPasswordManualReExamPassword = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    total_exam_marks: z.number().optional(),
    password_type: z.string().optional(),
    password: z.string().optional(),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().nonempty({ message: "Re-Exam Password is required" }),
    result_publish_date: z.string().nonempty({ message: "Result Publish Date is required" }),
    result_publish_time: z.string().nonempty({ message: "Result Publish Time is required" }),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
}).refine(data => {
    const passingMarks = parseFloat(data.passing_marks);
    const totalExamMarks = parseFloat(data.total_exam_marks);

    // Ensure the parsed numbers are valid
    if (isNaN(passingMarks) || isNaN(totalExamMarks)) {
        return false;
    }

    return passingMarks <= totalExamMarks;
}, {
    message: "Passing Marks must be less than or equal to Total Exam Marks",
    path: ["passing_marks"],
});

export const assignExamFormResultShowValidationRandomPasswordAutonReExamPassword = z.object({
    start_date: z.string().nonempty({ message: "Start Date is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_date: z.string().nonempty({ message: "End Date is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    pattern_id: z.string().nonempty({ message: "Pattern is required" }),
    test_type_id: z.string().nonempty({ message: "Test Type is required" }),
    ideal_time_per_question: z.string().nonempty({ message: "Time Per Question is required" }),
    passing_marks: z.string().nonempty({ message: "Passing Marks is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    divisions: z.array(z.string()).nonempty({ message: "Division is required" }),
    total_exam_marks: z.number().optional(),
    password_type: z.string().optional(),
    password: z.string().optional(),
    re_exam_password_type: z.string().optional(),
    re_exam_password: z.string().optional(),
    result_publish_date: z.string().nonempty({ message: "Result Publish Date is required" }),
    result_publish_time: z.string().nonempty({ message: "Result Publish Time is required" }),
    exam_mode: z.preprocess((val) => Number(val), z.number().positive({ message: "Exam Mode is required" }))
}).refine(data => {
    const passingMarks = parseFloat(data.passing_marks);
    const totalExamMarks = parseFloat(data.total_exam_marks);

    // Ensure the parsed numbers are valid
    if (isNaN(passingMarks) || isNaN(totalExamMarks)) {
        return false;
    }

    return passingMarks <= totalExamMarks;
}, {
    message: "Passing Marks must be less than or equal to Total Exam Marks",
    path: ["passing_marks"],
});



export const sectionUploadCompetitiveExamFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitive Exam is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    // lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    file: z.string().nonempty({ message: "xlsx File is required" }),
});

export const sectionUploadPdfExamFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    subject_ids: z.array(z.any()).nonempty({ message: "Subject is required" }),
    pdf_url: z.string().nonempty({ message: "pdf File is required" }),
    total_questions: z
        .string() // Define as string schema
        .transform(value => parseFloat(value)) // Transform string input to number
        .refine(value => !isNaN(value) && value >= 1, { // Validate transformed number
            message: "Total questions must be a number and at least 1",
        }),
});

export const instituteSectionTeacherPerformanceFormValidation = z.object({
    sectionMasterId: z.preprocess((val) => Number(val), z.number().positive({ message: "Section Name is required" })),
    academicYearMasterId: z.preprocess((val) => Number(val), z.number().positive({ message: "Academic Year is required" }))
});

export const sectionStudentActivityFormValidation = z.object({
    day_type: z.string().nonempty({ message: "Day is required" }),
    start_time: z.string().nonempty({ message: "Start Time is required" }),
    end_time: z.string().nonempty({ message: "End Time is required" }),
    activity: z.string().nonempty({ message: "Activity is required" })
});

export const appVersionUpdateFormValidation = z.object({
    version_name: z.string().nonempty({ message: "Version Name is required" }),
    version_code: z.string().nonempty({ message: "Version Code is required" })
});

export const sectionTeacherPerformanceFormValidation = z.object({
    academicYearMasterId: z.string().nonempty({ message: "Academic Year is required" }),
    startDate: z.string().nonempty({ message: "Start Date is required" }),
    endDate: z.string().nonempty({ message: "End is required" })
});

export const sectionStudentAttendanceFormValidation = z.object({
    instituteGradeMasterId: z.string().nonempty({ message: "Class is required" }),
    instituteDivisionMasterId: z.string().nonempty({ message: "Division is required" }),
    month: z.string().nonempty({ message: "Month is required" })
});

export const studentLocationFormValidation = z.object({
    instituteMasterId: z.string().nonempty({ message: "Institute is required" }),
    sectionMasterId: z.string().nonempty({ message: "Section is required" }),
    academicYearMasterId: z.string().nonempty({ message: "Academic Year is required" }),
    instituteGradeMasterId: z.string().nonempty({ message: "Class is required" }),
    instituteDivisionMasterId: z.string().nonempty({ message: "Division is required" }),
    studentId: z.string().nonempty({ message: "Student is required" })
});

export const studentLocationUsingDeviceIdFormValidation = z.object({
    instituteMasterId: z.string().optional(),
    sectionMasterId: z.string().optional(),
    academicYearMasterId: z.string().optional(),
    instituteGradeMasterId: z.string().optional(),
    instituteDivisionMasterId: z.string().optional(),
    isDevice: z.boolean().optional(),
    studentId: z.string().optional(),
    deviceId: z.string().nonempty({ message: "Device Id is required" })
})

export const generateCouponCodeFormValidation = z.object({
    subscriptionMasterId: z.string().nonempty({ message: "Plan is required" }),
    quantity: z.string().nonempty({ message: "Quantity is required" }),
    expiry: z.string().nonempty({ message: "Expiry Date is required" })
})

export const generateCouponCodeEditFormValidation = z.object({
    subscriptionMasterId: z.string().nonempty({ message: "Plan is required" }),
    quantity: z.string().nonempty({ message: "Quantity is required" }),
    expiry: z.string().nonempty({ message: "Expiry Date is required" }),
    code: z.string().nonempty({ message: "Code is required" })
})


export const instituteExamRequestFormValidation = z.object({
    sectionMasterId: z.string().nonempty({ message: "Section is required" })
})

export const adminExamRequestFormValidation = z.object({
    instituteMasterId: z.string().nonempty({ message: "Institute is required" }),
    sectionMasterId: z.string().nonempty({ message: "Section is required" })
})

export const adminBranchMasterFormValidation = z.object({
    instituteMasterId: z.string().nonempty({ message: "Institute is required" }),
    branchName: z.string().nonempty({ message: "Branch Name is required" }),
    branchInchargeName: z.string().nonempty({ message: "Branch Incharge Name is required" }),
    email: z.string().nonempty({ message: "email is required" })
})

export const adminDepartmentMasterFormValidation = z.object({
    instituteMasterId: z.string().nonempty({ message: "Institute is required" }),
    branchId: z.string().nonempty({ message: "Branch is required" }),
    email: z.string().nonempty({ message: "email is required" })
})



/* Create Exam Paper Validation Start */
export const textBookExamCreateSingleSubjectBlankQuestionCreteExamPaperFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
    exam_total_marks: z.string().nonempty({ message: "Exam Total Marks is required" })
});
export const textBookExamCreateMultipleSubjectCreteExamPaperFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().optional(),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
    exam_total_marks: z.string().nonempty({ message: "Exam Total Marks is required" })
});
export const textBookExamCreateSingleSubjectCreteExamPaperFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    syllabus_structure_id: z.string().nonempty({ message: "Syllabus Structure is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
    exam_total_marks: z.string().nonempty({ message: "Exam Total Marks is required" })
});


// competitive Exam Paper 
export const competitiveExamCreateSingleSubjectBlankQuestionCreteExamPaperFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().nonempty({ message: "Lesson is required" }),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
    exam_total_marks: z.string().nonempty({ message: "Exam Total Marks is required" })
});
export const competitiveExamCreateMultipleSubjectCreteExamPaperFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().optional(),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
    exam_total_marks: z.string().nonempty({ message: "Exam Total Marks is required" })
});
export const competitiveExamCreateSingleSubjectCreteExamPaperFormValidation = z.object({
    exam_name: z.string().nonempty({ message: "Exam Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    class_id: z.string().nonempty({ message: "Class is required" }),
    book_id: z.string().nonempty({ message: "Book is required" }),
    competitive_exam_id: z.string().nonempty({ message: "Competitve Exam is required" }),
    subject_id: z.string().nonempty({ message: "Subject is required" }),
    lesson_id: z.string().optional(),
    topic_id: z.string().optional(),
    subtopic_id: z.string().optional(),
    questions: z.array(z.any()).nonempty({ message: "At least one question is required" }),
    exam_total_marks: z.string().nonempty({ message: "Exam Total Marks is required" })
});

/* Create Exam Paper Validation End */



// Migrate Competitive Exam Master Name Form Validation
export const migrateCompetitiveExamMasterNameFormValidation = z.object({
    newCompetitiveExamNameMasterId: z.string().nonempty({ message: "New Competitive Exam Name is required" }),
    oldCompetitiveExamNameMasterId: z.string().nonempty({ message: "Old Competitive Exam Name is required" }),
    competitiveExamBookMasterId: z.string().nonempty({ message: "Competitive Exam Book is required" })
});

// Migrate Competitive Exam Subject Form Validation
export const migrateCompetitiveExamSubjectFormValidation = z.object({
    newCompetitiveExamNameMasterId: z.string().nonempty({ message: "New Competitive Exam Name is required" }),
    newCompetitiveExamBookMasterId: z.string().nonempty({ message: "New Competitive Exam Book is required" }),

    oldCompetitiveExamNameMasterId: z.string().nonempty({ message: "Old Competitive Exam Name is required" }),
    oldCompetitiveExamBookMasterId: z.string().nonempty({ message: "Old Competitive Exam Book is required" }),
    oldCompetitiveExamSubjectMasterId: z.string().nonempty({ message: "Competitive Exam Subject is required" })
});

export const examDownloadReportFormValidation = z.object({
    month: z.string().nonempty({ message: "Month is required" }),
    exam_id: z.string().nonempty({ message: "Exam is required" })
});

export const teacherVideoListFormValidation = z.object({
    academicYearMasterId: z.string().nonempty({ message: "Academic Year is required" }),
    teacherMasterId: z.string().nonempty({ message: "Teacher is required" })
});


export const studentDataStudentCredentialFormValidation = z.object({
    studentName: z.string().nonempty({ message: "Student Name is required" }),
    email: z.string().nonempty({ message: "Email is required" }),
    primaryContact: z.string().nonempty({ message: "Primary Contact is required" }),
    secondaryContact: z.string().nonempty({ message: "Secondary Contact is required" }),
    gender: z.string().nonempty({ message: "Gender is required" })
});


export const appInstituteSectionGradeMappingFormValidation = z.object({
    // instituteMasterId: z.string().nonempty({ message: "Institute is required" }),
    sectionMasterId: z.string().nonempty({ message: "Section is required" }),
    instituteGradeMasterIds: z.array(z.any()).nonempty({ message: "Grade is required" }),
});

export const sectionDssComplainFormValidation = z.object({
    academicYearMasterId: z.string().nonempty({ message: "Academic year is required" })
});

export const subscriptionFormValidation = z.object({
    subscriptionName: z.string().nonempty({ message: "Subscription Name is required" }),
    amount: z.string().nonempty({ message: "Amount is required" }),
    menu: z.array(z.any()).nonempty({ message: "At least one menu is required" }),
    color: z.string().nonempty({ message: "Color is required" }),
    details: z.string().nonempty({ message: "Details is required" }),
});

export const appMenuFormValidation = z.object({
    menuName: z.string().nonempty({ message: "Menu Name is required" }),
});

export const aboutUsDetailsFormValidation = z.object({
    aboutUsDetails: z.string().nonempty({ message: "Details is required" }),
});

export const adminSubjectBlockFormValidation = z.object({
    instituteMasterId: z.string().nonempty({ message: "Institute is required" }),
    sectionMasterId: z.string().nonempty({ message: "Section is required" }),
    instituteSubjectMasterId: z.string().nonempty({ message: "Subject is required" })
})

export const adminPaperPatternAddFormValidation = z.object({
    examPatternMasterId: z.string().nonempty({ message: "Exam pattern is required" }),
    subjectMasterId: z.string().nonempty({ message: "Subject is required is required" }),
    questionTypeMasterId: z.string().nonempty({message: "Question type is required"})
})

export const copyTestFormValidation = z.object({
    class_id: z.string().nonempty({ message: "Class is required" }),
    month: z.string().nonempty({ message: "Month is required" }),
    examMasterId: z.string().nonempty({ message: "Exam is required" }),
    reNameTest: z.string().nonempty({ message: "Re-name test is required" })
})